/**
 *   Docutain SDK Capacitor
 *   Copyright (c) INFOSOFT Informations- und Dokumentationssysteme GmbH. All rights reserved.
 *
 *   Docutain SDK Capacitor is a commercial product and requires a license.
 *   Details found in the LICENSE file in the root directory of this source tree.
 */

import { WebPlugin } from '@capacitor/core';

import type {
  DocutainSDKPlugin,
  InitSDKOptions,
  ScanDocumentResult,
  LoadFileOptions,
  GetTextPageOptions,
  GetTextResult,
  GetTextPageResult,
  AnalyzeConfigurationOptions,
  WritePDFOptions,
  WritePDFResult,
  DocumentScannerConfiguration,
  StartDocumentScannerOptions,
  StartPhotoPaymentOptions,
  StartPhotoPaymentResult,
  AnalyzeConfiguration,
  ResetOnboardingOptions,
  ScanTipsDefaultItemsResult,
  OnboardingDefaultItemsResult,
  EmptyResultScreenDefaultItemsResult,
  AnalyzeResult,
  GetTraceFileResult,
  SetLogLevelOptions,
  DeleteTempFilesOptions,
  WriteImageOptions,
  WriteImageResult,
  GetImageBytesResult,
  GetImageBytesOptions,
  PageCountResult,
} from './definitions';

export class DocutainSDKWeb extends WebPlugin implements DocutainSDKPlugin {
  async initSDK(_options: InitSDKOptions): Promise<void> {
    throw this.unimplemented('initSDK not implemented on web.');
  }

  async scanDocument(_args: {
    config: DocumentScannerConfiguration;
  }): Promise<ScanDocumentResult> {
    throw this.unimplemented('scanDocument not implemented on web.');
  }

  async startDocumentScanner(
    _options: StartDocumentScannerOptions,
  ): Promise<void> {
    throw this.unimplemented('scanDocument not implemented on web.');
  }

  async loadFile(_options: LoadFileOptions): Promise<void> {
    throw this.unimplemented('loadFile not implemented on web.');
  }

  async getText(): Promise<GetTextResult> {
    throw this.unimplemented('getText not implemented on web.');
  }

  async getTextPage(_options: GetTextPageOptions): Promise<GetTextPageResult> {
    throw this.unimplemented('getTextPage not implemented on web.');
  }

  async setAnalyzeConfiguration(_args: {
    config: AnalyzeConfiguration;
  }): Promise<void> {
    throw this.unimplemented('setAnalyzeConfiguration not implemented on web.');
  }

  async setAnalyzeConfigurationDocScan(
    _options: AnalyzeConfigurationOptions,
  ): Promise<void> {
    throw this.unimplemented(
      'setAnalyzeConfigurationDocScan not implemented on web.',
    );
  }

  async analyze(): Promise<AnalyzeResult> {
    throw this.unimplemented('analyze not implemented on web.');
  }

  async writePDF(_options: WritePDFOptions): Promise<WritePDFResult> {
    throw this.unimplemented('writePDF not implemented on web.');
  }

  async setLogLevel(_options: SetLogLevelOptions): Promise<void> {
    throw this.unimplemented('setLogLevel not implemented on web.');
  }

  async getTraceFile(): Promise<GetTraceFileResult> {
    throw this.unimplemented('getTraceFile not implemented on web.');
  }

  async deleteTempFiles(_options: DeleteTempFilesOptions): Promise<void> {
    throw this.unimplemented('deleteTempFiles not implemented on web.');
  }

  async writeImage(_options: WriteImageOptions): Promise<WriteImageResult> {
    throw this.unimplemented('writeImage not implemented on web.');
  }

  async getImageBytes(
    _options: GetImageBytesOptions,
  ): Promise<GetImageBytesResult> {
    throw this.unimplemented('writeImage not implemented on web.');
  }

  async pageCount(): Promise<PageCountResult> {
    throw this.unimplemented('writeImage not implemented on web.');
  }

  async resetOnboarding(_options: ResetOnboardingOptions): Promise<void> {
    throw this.unimplemented('resetOnboarding not implemented on web.');
  }

  async onboardingDefaultItems(): Promise<OnboardingDefaultItemsResult> {
    throw this.unimplemented('onboardingDefaultItems not implemented on web.');
  }

  async scanTipsDefaultItems(): Promise<ScanTipsDefaultItemsResult> {
    throw this.unimplemented('scanTipsDefaultItems not implemented on web.');
  }

  async startPhotoPayment(
    _options: StartPhotoPaymentOptions,
  ): Promise<StartPhotoPaymentResult> {
    throw this.unimplemented('startPhotoPayment not implemented on web.');
  }

  async emptyResultScreenDefaultItems(): Promise<EmptyResultScreenDefaultItemsResult> {
    throw this.unimplemented(
      'emptyResultScreenDefaultItems not implemented on web.',
    );
  }
}
